import localForage from 'localforage'

const store = localForage.createInstance({ name: 'toggleStates' })

const DEFAULT_EXPANDED_STATE = false

export const ToggleStateStorage = {
  getToggleState: async (uuid: string): Promise<boolean> => {
    const storedValue = await store.getItem<boolean>(uuid)
    if (storedValue === null) return DEFAULT_EXPANDED_STATE

    return storedValue
  },
  setToggleState: (uuid: string, expanded: boolean) => {
    // NOTE: this is only here for testing, DO NOT RELY ON IT IN PRODUCTION!
    ;(window as any).unsavedToggleState = true

    return store.setItem(uuid, expanded).then(() => {
      delete (window as any).unsavedToggleState
    })
  },
}
